import { render } from "./TradingSessionSummary.vue?vue&type=template&id=52523e88"
import script from "./TradingSessionSummary.vue?vue&type=script&lang=js"
export * from "./TradingSessionSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__